/**
 * Role license code format (must match server generateRoleLicenseCode).
 * Example: SPX-STD-F05C-C0F8-82F1-C975
 */
export const ROLE_LICENSE_CODE_PATTERN =
  /^SPX-(ADM|TCH|STD)-[A-F0-9]{4}-[A-F0-9]{4}-[A-F0-9]{4}-[A-F0-9]{4}$/;

/** Max length of a normalized license code (including dashes). */
export const ROLE_LICENSE_CODE_MAX_LEN = 27;

/**
 * Normalize + validate license input for client-side gatekeeping.
 * @returns {string|null} normalized code or null if invalid
 */
export function normalizeAndValidateLicenseCode(raw) {
  const normalized = String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '');
  if (!normalized || !ROLE_LICENSE_CODE_PATTERN.test(normalized)) return null;
  return normalized;
}

/** Strip characters that can never appear in a valid license code. */
export function sanitizeLicenseCodeInput(raw) {
  return String(raw || '')
    .toUpperCase()
    .replace(/[^A-Z0-9-]/g, '')
    .slice(0, ROLE_LICENSE_CODE_MAX_LEN);
}
